import { request } from '../../utils/request/request';

type APIResponse = {
  country_code: string;
};

export type GeolocationResponse = {
  countryCode: string;
};

const geolocation = {
  fetch: async (): Promise<GeolocationResponse> => {
    try {
      const response = (await request('/localize')) as APIResponse;

      return adaptResponse(response);
    } catch (_err) {
      throw new Error('Failed to fetch geolocation data');
    }
  },
};

const adaptResponse = (response: APIResponse): GeolocationResponse => {
  return {
    countryCode: response.country_code,
  };
};

export { geolocation };
